import { Component, OnInit } from '@angular/core';

import {
  AuthenticationService} from '../data-services/index';

import {
  HelpApiService,
  IContact, IHelp, IUser} from '@ebb-v2/ebb-integration';

@Component({
    selector: 'ebb-portal-training-emr',
    templateUrl: './training-emr.component.html',
    standalone: false
})
export class TrainingEMRComponent implements OnInit {
  public currentUser: IUser;
  public currentContact: IContact;
  public trainingType:string;
  public listHelp: IHelp[] = [];
  public textFemaTraining:string;
  constructor(
    private readonly authenticationService: AuthenticationService,
    private apiHelp: HelpApiService
    
  ) { }

  ngOnInit() {
    
    this.currentUser = this.authenticationService.currentUserValue;
 this.trainingType ='700000002';
 this.loadHelpText();
  }
  private loadHelpText(): void {
    this.apiHelp
      .getList()
      .subscribe(
        data => {
          this.listHelp = [...data];
          const indexHelpContractor = this.listHelp.findIndex(i => i.name === 'Fema Training Earthquake Multi-Unit Course');
          if (indexHelpContractor >= 0)
            this.textFemaTraining = this.listHelp[indexHelpContractor].answer;
         
        },
        error => console.log(error)
      );
  }
 

 

  public isContractor(): boolean {
    return this.authenticationService.isContractor(this.currentUser);
  }
}
